export default __webpack_public_path__ + "static/media/test-failed.b47f1523.svg";